import { motion } from "framer-motion";
import { House, Sparkle, Package, Buildings, Bed, Broom } from "@phosphor-icons/react";
import { SERVICES } from "@/data/content";

const ICONS = { House, Sparkle, Package, Buildings, Bed, Broom };

// bento spans: index -> col span classes (12-col grid)
const SPANS = [
  "md:col-span-5",
  "md:col-span-4",
  "md:col-span-3",
  "md:col-span-4",
  "md:col-span-4",
  "md:col-span-4",
];

export default function Services() {
  return (
    <section id="services" className="py-16 md:py-32 bg-background" data-testid="services-section">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-14">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-3">Our Services</p>
          <h2 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-primary">
            Cleaning services built around your needs
          </h2>
          <p className="mt-4 text-foreground/70 text-lg">
            Choose the service that fits your home, office or property.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.article
                key={s.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                className={`group relative overflow-hidden rounded-3xl border border-border bg-card p-8 ${SPANS[i]} hover:-translate-y-1.5 hover:shadow-xl transition-all duration-300`}
                data-testid={`service-card-${i}`}
              >
                {s.image && (
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-primary/85" />
                  </div>
                )}
                <div className="relative z-10">
                  <div className="w-14 h-14 rounded-2xl bg-secondary flex items-center justify-center mb-6 group-hover:bg-white/15 transition-colors">
                    <Icon size={28} weight="duotone" className="text-primary group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="font-heading text-2xl font-normal text-primary group-hover:text-white transition-colors">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-foreground/70 group-hover:text-white/85 leading-relaxed transition-colors">
                    {s.desc}
                  </p>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
